import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import Section from '../Section'
import { TNormalizedService } from '../../types/serviceView'

const SERVICE_DETAIL_MIN_HEIGHT = 'calc(100vh - 260px)'

type TProps = {
    service: TNormalizedService
    children?: React.ReactNode
    onBack?: () => void
}

const ServiceDetailLayout: React.FC<TProps> = ({
    service,
    children,
    onBack,
}) => (
    <div
        className="animated fadeIn mb-5"
        data-testid="service-detail-layout"
        style={{ minHeight: SERVICE_DETAIL_MIN_HEIGHT }}
    >
        <Row>
            <Col>
                {onBack ? (
                    <Button
                        color="secondary"
                        size="sm"
                        className="mb-3"
                        onClick={onBack}
                        data-testid="service-detail-back"
                    >
                        <i className="icon-arrow-left mr-2" />
                        Back
                    </Button>
                ) : null}
                <Section title={service.name || service.productCode}>
                    <div className="mt-3">{children}</div>
                </Section>
            </Col>
        </Row>
    </div>
)

export default ServiceDetailLayout
